import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid, 
  Card, 
  CardContent, 
  CardActions, 
  Button,
  Divider
} from '@mui/material';
import { 
  Email, 
  CloudUpload
} from '@mui/icons-material';
import EmailSetup from './emailSetup/EmailSetup';
import BudgetCodeUpload from './budgetCodeUpload/BudgetCodeUpload';
import usePageTitle from '../../utils/usePageTitle';

const Admin = () => {
  usePageTitle('System Administration');
  const [selectedModule, setSelectedModule] = useState(null);

  const adminModules = [
    {
      id: 'emailSetup',
      title: 'Email Setup',
      description: 'Configure email addresses for Carson system notifications',
      icon: <Email />,
      component: <EmailSetup />
    },
    {
      id: 'budgetCodeUpload',
      title: 'Budget Code Upload',
      description: 'Upload budget codes from Excel files',
      icon: <CloudUpload />,
      component: <BudgetCodeUpload />
    }
  ];

  const handleModuleSelect = (moduleId) => {
    setSelectedModule(moduleId);
  };

  const handleBackToAdmin = () => {
    setSelectedModule(null);
  };

  if (selectedModule) {
    const module = adminModules.find(m => m.id === selectedModule);
    return (
      <Box>
        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Button 
            variant="outlined" 
            onClick={handleBackToAdmin}
            size="small"
          >
            ← Back to Admin
          </Button>
          <Typography variant="h5">
            {module?.title}
          </Typography>
        </Box>
        {module?.component}
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        System Administration
      </Typography>
      
      <Paper sx={{ p: 3, mb: 3 }} component="section" aria-labelledby="admin-description">
        <Typography variant="body1" color="text.secondary" id="admin-description">
          Manage Carson system configuration and administrative functions.
        </Typography>
      </Paper>

      <Box component="section" aria-labelledby="admin-modules-heading">
        <Typography variant="h5" component="h2" id="admin-modules-heading" sx={{ mb: 3, fontWeight: 600 }}>
          Administrative Modules
        </Typography>
        <Grid container spacing={3}>
        {adminModules.map((module) => (
          <Grid item xs={12} sm={6} md={4} key={module.id}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  {module.icon}
                  <Typography variant="h6" sx={{ ml: 1 }}>
                    {module.title}
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {module.description}
                </Typography>
              </CardContent>
              <Divider />
              <CardActions>
                <Button 
                  size="small" 
                  variant="contained"
                  onClick={() => handleModuleSelect(module.id)}
                  fullWidth
                >
                  Open
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
      </Box>
    </Box>
  );
};

export default Admin;